module.exports = __webpack_public_path__ + "static/media/installation.19ad5173.mp4";